
import PropTypes from 'prop-types'

const basePropTypes = {
  name: PropTypes.string,
  previousStep: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  isShowNext: PropTypes.func.isRequired,
  isShowPrevious: PropTypes.func.isRequired,
  isFirstStep: PropTypes.func.isRequired,
  isLastStep: PropTypes.func.isRequired,
  getCurrentStepIndex: PropTypes.func.isRequired,
}

const StepperType = PropTypes.shape(basePropTypes)

export const StepperTypeForStepSwitch = PropTypes.shape({
  ...basePropTypes,
  switchStepIdentifier: PropTypes.shape({
    index: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
})

export default StepperType
